import Subcategory from './subcategory';

export default Subcategory;